import { Button, Typography } from '@mui/material';
import { SetStateAction } from 'jotai';
import React, { Dispatch } from 'react';
import { OrganizationInput } from 'sr-types/lib/organization/v1/graphql';
import { PersonInput } from 'sr-types/lib/person/v1/graphql';
import { ENTITY_CONSTANTS } from '../common/constants/entityConstants';
import I18n from '../common/i18n/I18n';
import { V } from '../common/Layout';
import { PERSON_TYPE } from '../person/utils/personConstants';
import { extractNames } from './helpers/peopleUtils';

type SearchOrCreateResultProps = {
    query: string;
    setAllSearch: (value: boolean) => void;
    setIsCreate: (value: boolean) => void;
    setState: Dispatch<SetStateAction<PersonInput | OrganizationInput>>;
    state: PersonInput | OrganizationInput;
    type?: string;
    isSearchedInDirectory?: boolean;
};
export default function SearchOrCreateResult({
    query,
    setAllSearch,
    setIsCreate,
    setState,
    state,
    type,
    isSearchedInDirectory = false
}: SearchOrCreateResultProps) {
    return (
        <V fill sx={{ alignItems: 'center', justifyContent: 'center' }}>
            {type !== ENTITY_CONSTANTS.activity && !isSearchedInDirectory && (
                <>
                    <Button onClick={() => setAllSearch(true)}>
                        <Typography>
                            <I18n token="production.results.searchDirectory.for" values={{ name: query }} />
                        </Typography>
                    </Button>
                    <Typography sx={{ textTransform: 'uppercase' }}>
                        <I18n token="common.or.label" />
                    </Typography>
                </>
            )}

            <Button
                onClick={() => {
                    setIsCreate(true);
                    setState({
                        ...state,
                        ...(type === PERSON_TYPE ? { name: extractNames(query) } : { publicName: query })
                    });
                }}
            >
                <Typography>
                    <I18n
                        token={
                            type === PERSON_TYPE
                                ? 'form.person.createNewPerson'
                                : type === ENTITY_CONSTANTS.activity
                                  ? 'form.addNew.activity'
                                  : 'form.key.organization.create'
                        }
                        values={{ name: query }}
                    />
                </Typography>
            </Button>
        </V>
    );
}
